define('GameDayCore/GDModel/ValueObjects/Players/PlayerModel',['require','exports','module','message-service/message-service','../ValueObjectFactory','jquery','../../../GDUtil/window/Logg','extant/extant','../../../GDControl/GameModelLocator/GameModelLocator','gameday-resource-path/gameday-resource-path','../../../GDUtil/window/Logg','../../enums/baseball/PlayerTypes'],function(require, exports, module) {
    var MessageService = require("message-service/message-service"),
        VO = require('../ValueObjectFactory'),
        $ = require('jquery'),
        logg = require('../../../GDUtil/window/Logg'),
        exists = require("extant/extant"),
        GameModelLocator = require('../../../GDControl/GameModelLocator/GameModelLocator'),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        logg = require("../../../GDUtil/window/Logg");

    VO.create(PlayerModel);

    /**
     * Class PlayerModel
     * @param $ID {String} player id (or pid) of the player.
     * @param $type {String} 'b' or 'p' expected, display stats for this player as a batter or a pitcher.
     * @author ams after Merryman
     *
     * a multiplexed view of a player. can be constructed for
     * pitching or batting scenario. This object is to be
     * created at the time it is to be used. It will
     * form as complete a snapshot of the player stats
     * as available data allows.
     *
     * Almost every data point is a request-time xml query using
     * getters, so as little processing as possible is used to
     * form the model.
     *
     * Not all the stat abbreviations in this class
     * conform to official Baseball standards. For more
     * information about standard stat abbreviations, consult
     * http://footballmogul.com/content/Abbreviations.html
     */
    function PlayerModel($ID, $type, gameID) {
        var vo   = VO.ensureVO(this, PlayerModel),
            self = this,
            gameItem  = GameModelLocator.retrieveGameFromCache(gameID),
            gameModel,
            playerType = $type;

        if(exists(gameItem)){
            gameModel = gameItem.getGameData();
        }else {
            return vo;
        }
        // files needed
        var rosterFileModel = getPlayerRosterFile($ID,gameModel),
            boxPlayer = getVerifiedBoxModel($ID,$type,gameModel),
            playsFile = gameModel.play,
            gamefile = gameModel.game,
            PlayerTypes = require("../../enums/baseball/PlayerTypes"),
            playsDefensePlayerModel = playsFile.findFieldPlayer($ID),
            playsBaserunnerPlayerModel = playsFile.findBaseRunner($ID),
        // logical breakdowns
            home_or_away = (rosterFileModel.isHome) ? "home" : "away",
            isCurrentPitcher = ($ID == playsFile.pitcher.pid), // pitchers
            isLiveBatter = ($ID == playsFile.batter.pid),
            isBaserunner = (playsBaserunnerPlayerModel !== null), // batters
            isDefender = (playsDefensePlayerModel !== null), // batters
            pitches = (playerType === PlayerTypes.P) ? parsePitches(playsFile,boxPlayer,isCurrentPitcher) : "--",
            strikes = (playerType === PlayerTypes.P) ? parseStrikes(playsFile,boxPlayer,isCurrentPitcher) : "--",
            balls = (playerType === PlayerTypes.P) ? parseBalls(playsFile,balls,strikes,isCurrentPitcher) : "--",
            uniform=rosterFileModel.parent_team_abbrev || ((home_or_away === "home") ? gamefile.home.abbrev : gamefile.away.abbrev);

        $.extend(vo, {
            playerModelType: playerType,
            player_id: $ID,
            pid: $ID,
            mugshot: resourcePath.get('mugshot', { pid: $ID}),
            team_id: exists(rosterFileModel, "parent_team_id") ? rosterFileModel.parent_team_id : gamefile[home_or_away].id,
            team_abbrev: (home_or_away === "home") ? gamefile.home.abbrev : gamefile.away.abbrev,
            parent_team_id: rosterFileModel.parent_team_abbrev || '',
            parent_team_abbrev: rosterFileModel.parent_team_abbrev || '',
            home_or_away: home_or_away,
            isCurrentPitcher: isCurrentPitcher,
            is_live_batter: isLiveBatter,
            // box details
            boxnote: boxPlayer.note || "",
            isOnBench: !exists(boxPlayer.name),
            pos: exists(boxPlayer.pos) ? boxPlayer.pos : rosterFileModel.position, // abbreviated position
            stand: (exists(playsFile, "atbat.stand")) ? playsFile.atbat.stand : "",
            b_height: (exists(playsFile, "atbat.height")) ? playsFile.atbat.height : "",
            getBatterImage : function(cut){
                cut=cut||'ipad';
                
               return resourcePath.get('batter',{
                    team    : uniform.toUpperCase(),
                    cut     : cut,
                    homeOrAway : home_or_away,
                    stand   : (exists(playsFile, "atbat.stand")) && playsFile.atbat.stand.toUpperCase()==="L"  ? "LEFT" : "RIGHT"
                });
            },
            // game stats
            h: boxPlayer.h || "", // players hits
            r: boxPlayer.r || "", // players runs
            hr: boxPlayer.hr || "", // players home runs
            bb: boxPlayer.bb || "", // num times player walked
            rbi: boxPlayer.rbi || "", // players rbis
            ab: boxPlayer.ab || "", // num times player at bat
            avg: boxPlayer.avg || "", // players batting avg
            d: boxPlayer.d || "",
            e: boxPlayer.e || "", // players errors
            lob: boxPlayer.lob || "", // baserunners left on base by player
            fldg: boxPlayer.fldg || "", // players fielding percentage
            //batter-only stats
            bo: boxPlayer.bo || "",
            po: boxPlayer.po || "",
            so: boxPlayer.so || "",
            t: boxPlayer.t || "",
            a: boxPlayer.a || "",
            //pitcher-only
            out: boxPlayer.out || "", // players thrown outs
            er: boxPlayer.er || "", // players earned runs
            w: boxPlayer.w || "", // players credited wins
            l: boxPlayer.l || "", // players credited losses
            era: boxPlayer.era || "", // players earned run avg
            ip: boxPlayer.ip || "", // num innings player pitched
            // seasons stats
            hrs: boxPlayer.s_hr || "", // Home runs by player during entire season
            rbis: boxPlayer.s_rbi || "", // rbis by player during entire season
            // Roster Vars
            first: rosterFileModel.first || "",
            last: rosterFileModel.last || "",
            boxname: rosterFileModel.boxname || "", // boxscore column display
            name: rosterFileModel.first + " " + rosterFileModel.last, // full name
            rl: (exists(rosterFileModel) && rosterFileModel.rl.length > 0) ? rosterFileModel.rl : "",
            num: rosterFileModel.num || "",
            // Plays vars
            //batter-only
            bnum: (isBaserunner) ? playsBaserunnerPlayerModel.bnum : "",
            note: (isBaserunner) ? playsBaserunnerPlayerModel.note : "",
            // season stats
            sb: (isBaserunner) ? playsBaserunnerPlayerModel.sb : "", // stolen bases
            cs: (isBaserunner) ? playsBaserunnerPlayerModel.cs : "", // caught stealing
            s_hr: boxPlayer.s_hr || "", // home runs
            s_rbi: boxPlayer.s_rbi || "", // runs batted in
            // pitcher-(as field player)-only
            s_po: (isDefender) ? playsDefensePlayerModel.s_po : "", // put outs
            s_ass: (isDefender) ? playsDefensePlayerModel.s_ass : "", // assists
            s_err: (isDefender) ? playsDefensePlayerModel.s_err : "", // errors
            s_fldg: (isDefender) ? playsDefensePlayerModel.s_fldg : "", // fielding percentage
            //current pitcher-only
            pitches: pitches,
            strikes: strikes,
            balls: balls
        });

    }

    function getPlayerRosterFile($ID,gameModel) {
        if (!exists(gameModel.players)) {
            logg.log(gameModel);
            return null;
        }
        return gameModel.players.findPlayer($ID);
    }

    function getVerifiedBoxModel($ID,$type,gameModel) {
        var box = gameModel.boxscore && gameModel.boxscore.findPlayer($ID, $type);
        if (!exists(box)) box = {};
        return box;
    }

    function parsePitches(playsFile,boxPlayer,isCurrentPitcher) {
        var ret = 0;
        if (isCurrentPitcher)
            ret = parseInt(playsFile.pitcher.pitches);
        else if (exists(boxPlayer.np))
            ret = parseInt(boxPlayer.np);
        return ret;
    }

    function parseStrikes(playsFile,boxPlayer,isCurrentPitcher) {
        var ret = 0;
        if (isCurrentPitcher)
            ret = parseInt(playsFile.pitcher.strikes);
        else if (exists(boxPlayer.s))
            ret = parseInt(boxPlayer.s);
        return ret;

    }

    function parseBalls(playsFile,balls,strikes,isCurrentPitcher) {
        var ret = 0;
        if (isCurrentPitcher)
            ret = parseInt(playsFile.pitcher.balls);
        else
            ret = pitches - strikes;
        return ret;
    }

    return PlayerModel;
});
